// IA Configuration — damage category thresholds
// Persisted to localStorage (per-device; shared deployment config can be added later).

const KEY = 'ia_config_v1';

export interface IAThresholds {
  minorMin:    number;   // % — default 15
  majorMin:    number;   // % — default 50
  destroyedMin:number;   // % — default 80
}

export const DEFAULT_THRESHOLDS: IAThresholds = {
  minorMin:     15,
  majorMin:     50,
  destroyedMin: 80,
};

export function loadIAConfig(): IAThresholds {
  try {
    const s = localStorage.getItem(KEY);
    return s ? { ...DEFAULT_THRESHOLDS, ...JSON.parse(s) } : { ...DEFAULT_THRESHOLDS };
  } catch { return { ...DEFAULT_THRESHOLDS }; }
}

export function saveIAConfig(cfg: IAThresholds): void {
  localStorage.setItem(KEY, JSON.stringify(cfg));
}

export function categoryFromPct(pct: number, cfg: IAThresholds): string {
  if (pct >= cfg.destroyedMin) return 'destroyed';
  if (pct >= cfg.majorMin)     return 'major';
  if (pct >= cfg.minorMin)     return 'minor';
  return 'affected';
}
